import React from 'react';
import { Icon, BaseIconProps } from '../../../CommonComponents/OPL/Icon/Icon';
import { EntityDTO } from '../../DocumentVault.meta';
import {
  getEntityIconClassName,
  isSharedCompositeEntityIcon,
  SHARED_ENTITY_OVERLAY_ICON,
} from '../Entity/Entity.meta';
import { StackedEntityIconWrapper } from './EntityIcon.styles';

interface Props extends BaseIconProps {
  entity: Pick<EntityDTO, 'type' | 'isSharedWithThirdParty' | 'isParentSharedWithThirdParty'>;
}

export const EntityIcon: React.FC<Props> = ({
  entity,
  color = 'neutral.500',
  fontSize,
  ...rest
}) => {
  const entityColor =
    entity.isSharedWithThirdParty && !entity.isParentSharedWithThirdParty ? 'primary.500' : color;
  if (isSharedCompositeEntityIcon(entity)) {
    return (
      <StackedEntityIconWrapper entityType={entity.type} fontSize={fontSize ?? 'h6'} {...rest}>
        <Icon className={getEntityIconClassName(entity)} color={entityColor} />
        <Icon className={SHARED_ENTITY_OVERLAY_ICON} color={entityColor} />
      </StackedEntityIconWrapper>
    );
  }

  return (
    <Icon
      className={getEntityIconClassName(entity)}
      color={entityColor}
      fontSize={fontSize ?? 'h6'}
      {...rest}
    />
  );
};
